import { NavItemProps } from './NavItem.types'
import { useTranslation } from 'react-i18next'
import { Language } from '../../i18n/constants'
import styles from './NavItem.module.css'

const NavItem = ({ label, icon, active = false, onClick }: NavItemProps) => {
  const { t, i18n } = useTranslation()

  // Check if current language is Myanmar
  const isMyanmarLanguage = i18n.language === Language.MY

  // Font size class: text-xs for Myanmar on mobile, text-sm for others on mobile
  const mobileFontSizeClass = isMyanmarLanguage ? 'text-xs' : 'text-sm'

  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        flex items-center gap-1 h-12
        px-4
        rounded-md
        ${active ? styles.navItemActive : styles.navItemInactive}
        cursor-pointer transition
        ${active ? 'bottom-nav-active font-semibold' : 'bottom-nav-inactive hover:text-[var(--bet-type-hover-text)]'}
      `}
    >
      <div className="text-xl">{icon}</div>
      <span className={`${mobileFontSizeClass} sm:text-sm`}>{t(label)}</span>
    </button>
  )
}

export default NavItem
